module.exports = __webpack_public_path__ + "static/img/home_data_1.6e1e412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_data_1.png
// module id = X1EJ
// module chunks = 1